module.exports = __webpack_public_path__ + "img/142.a4030daf.jpg";